import { render, staticRenderFns } from "./ConsulTable.vue?vue&type=template&id=5852c242&"
import script from "./ConsulTable.vue?vue&type=script&lang=js&"
export * from "./ConsulTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports